/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-25 10:37:08
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {MaintenanceRecordDOI} from "./api/maintenanceRecordApi";
import MaintenanceRecordService from "./service/maintenanceRecordService";
import './maintenanceRecord.less';

@Component({name: 'maintenance-record'})
export default class MaintenanceRecord extends BasicSearchPage<MaintenanceRecordService, MaintenanceRecordDOI.RowDataI, MaintenanceRecordDOI.QueryRowDataParamsI> {

    checkBoxShow = true
    
    @override
    renderHead(h) {
        return <div></div>
    }
    
	@override
	loadService () {
		this.service = new MaintenanceRecordService(this)
	}
}